module.exports = __webpack_public_path__ + "static/media/a3.22bbdef6.jpg";